<template>
  <div id="app">
    <!-- remember always wrap whole app with v-app to include properly vuetify styles
      -->
    <v-app>
      <notif-container />
      <transition
        mode="out-in"
        enter-active-class="animate__animated animate__fadeIn  animate__faster"
        leave-active-class="animate__animated animate__fadeOut  animate__faster"
      >
        <router-view></router-view>
      </transition>
    </v-app>
  </div>
</template>

<script>
import NotifContainer from "@/components/Notification/NotifContainer.vue";

export default {
  name: "App",
  components: {
    NotifContainer,
  },
};
</script>
<style>
@import "./assets/css/style.css";
@import "./assets/css/section_style.css";

.href {
  text-decoration: none;
}
</style>
